import { formatMoney } from "@/helpers/formatMoney";

export const formatEarnings = (value: number): string => `$${formatMoney(value)}`;
